import type { TeamTO } from '../../../../../../lib';

export const translateTeamToOptions = (teams: TeamTO[]) => {
  return teams.map((team) => {
    return {
      value: team.id,
      label: team.clinicName,
    };
  });
};
